import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'


const _hoisted_1 = { class: "pl-5 pt-3 pr-5" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "flex flex-row-reverse items-center gap-3" }
const _hoisted_4 = { class: "flex flex-row-reverse items-center" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_newTable = _resolveComponent("newTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "title flex items-center" }, [
        _createElementVNode("h1", null, "Archive Documents")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: _normalizeClass(["flex", _ctx.getAllArchiveDocumentsJson.length === 0 ? 'btndisabled pointer-events-none' : 'filterButton']),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
          }, [
            (_ctx.getAllArchiveDocumentsJson.length == 0)
              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
              : (_openBlock(), _createElementBlock("img", _hoisted_6)),
            _cache[1] || (_cache[1] = _createTextVNode(" Filters "))
          ], 2)
        ])
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("p", { class: "mt-3 headerText" }, " Document management. Often referred too as Document Management Systems (DMS), is the use Of a computer system and software to store. manage and track electronic documents and electronic images of paper-based information captured through the use of a document scanner. Document management is how your organization stores. manages, and tracks its electronic documents. According to ISO 12651-2, a document is \"recorded information or object which can be treated as a unit.\" ", -1)),
    _createVNode(_component_newTable, {
      tableRowData: _ctx.getAllArchiveDocumentsJson,
      headersData: _ctx.documentHeaders,
      openPopup: true,
      loadData: _ctx.dataLoading
    }, null, 8, ["tableRowData", "headersData", "loadData"])
  ]))
}